import { IconButton } from '@apia/components';
import { Box } from '@apia/theme';

export const ImageIcon = ({
  deletable,
  onClick,
  onRemove,
  src,
}: {
  deletable: boolean;
  onClick: () => unknown;
  onRemove: () => unknown;
  src: string;
}) => {
  return (
    <Box className="image_preview">
      {deletable && (
        <IconButton icon="Close" size="Xs" iconSize="Xs" onClick={onRemove} />
      )}
      <img src={src} onClick={onClick} />
    </Box>
  );
};
